import { ReactNode } from 'react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { Container, Label, Value } from './notificationModalRow.styles';

type Props = {
  backgroundThemeColor?: ThemeColorType;
  icon: ReactNode;
  label: string;
  value: ReactNode;
};

export const NotificationModalRow = ({ backgroundThemeColor, icon, label, value }: Props) => (
  <Container backgroundThemeColor={backgroundThemeColor}>
    <Label>
      {label} {icon}
    </Label>
    <Value>{value}</Value>
  </Container>
);
